import React from "react";
import ApiCommunityDirectoryPage from "./ApiCommunityDirectoryPage";

export default function Jamaican() {
  return (
    <ApiCommunityDirectoryPage
      community="Jamaican"
      eyebrow="Jamaican community guide"
      title="Jamaican favorites, businesses, and local essentials in San Antonio."
      
      tags={["Jamaican community", "San Antonio", "Local businesses"]}
      claimText="Want your business featured in the Jamaican community guide?"
      modalIdPrefix="jamaican-directory"
    />
  );
}
